// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip_icon__KPELW"};